import React, { useEffect, useState } from 'react';
import { Select, DatePicker } from 'antd';
import type { ColumnsType } from 'antd/es/table';
import { MasterConfigs } from '../../../../../../../interfaces/entity';
import ReusableTable from '../../../../../../../components/TableComponent';
import { getData } from '../../../../../../../actions/apiCall';
import { useDispatch } from 'react-redux';
import dayjs, { Dayjs } from 'dayjs';


const { RangePicker } = DatePicker;


interface BDERecord {
  _id: string;
  date: string;
  createdCount: number;
  lost: number;
  won: number;
  inProgress: number;
  followUpMissed: number;
  followUpDone: number;
}

const WorkLog: React.FC = () => {
  const [filters, setFilters] = useState({
    employee: undefined,
    type: undefined,
    dateRange: null,
  });


  const [employeeOptions, setEmployeeOptions] = useState<
    { value: string; label: string }[]
  >([]);
  const [startDate, setStartDate] = useState<Dayjs | null>(null);
  const dispatch = useDispatch();

  useEffect(() => {
    getEmployees();
  }, []);

  const getEmployees = async () => {
    const res = await dispatch(getData('/users'));

    if (res?.data) {
      const options = res.data.map((item: any) => ({
        value: item.firstName,
        label: item.firstName,
      }));

      setEmployeeOptions(options);
    }
  };
  const disabledDate = (current: Dayjs) => {

    if (startDate) {
      return current.isBefore(startDate.startOf('day'));
    }
    return false;
  };

  const tableConfig: MasterConfigs = {
    api: () => '/bde-dashboard', // Updated endpoint name
    loadPagination: true,
    queryParams: {
      ...filters,
    },

    renderComponent: () => (
      <div className="flex justify-between items-center mb-4">
        <h3 className="text-lg font-semibold text-gray-700">BDE Details</h3>
        <div className="flex gap-3">
          <Select
            defaultValue="Priya sharma"
            className="w-40"
            allowClear
            onChange={(val) => setFilters({ ...filters, employee: val })}
            options={employeeOptions}

          />
          <Select
            placeholder="Type"
            className="w-28"
            allowClear
            onChange={(val) => setFilters({ ...filters, type: val })}
            options={[{ value: 'sales', label: 'Sales' }]}
          />
          <RangePicker
            style={{ width: 220 }}
            disabledDate={disabledDate}
            onChange={(dates) => setFilters({ ...filters, dateRange: dates })}
            onCalendarChange={(dates) => {
              setStartDate(dates?.[0] || null);
            }}
          />
        </div>
      </div>
    ),


    getColumns: (): ColumnsType<BDERecord> => [
      {
        title: 'Date',
        dataIndex: 'date',
        key: 'date',
        align: 'left',
      },
      {
        title: 'Created Count',
        dataIndex: 'createdCount',
        align: 'center',
      },
      {
        title: 'Lost',
        dataIndex: 'lost',
        align: 'center',
      },
      {
        title: 'Won',
        dataIndex: 'won',
        align: 'center',
      },
      {
        title: 'In Progress',
        dataIndex: 'inProgress',
        align: 'center',
      },
      {
        title: 'Follow-up Missed',
        dataIndex: 'followUpMissed',
        align: 'center',
      },
      {
        title: 'Follow-up Done',
        dataIndex: 'followUpDone',
        align: 'center',
      },
    ],

    tableProps: {
      bordered: false,
      className: "custom-table-header",
    },
  };

  return (

    <div className="rounded-xl shadow-sm">
      <ReusableTable<BDERecord> config={tableConfig} />
    </div>

  );
};

export default WorkLog;